import { BusinessInformationOccupantListItem } from '@centecomm/portal-service';
import { LoadStatus } from 'Types';
import { Occupant } from '../Types';

// eslint-disable-next-line import/prefer-default-export
export const mapBusinessAPIOccupantToOccupant = ({
    occupantId,
    occupantName,
    propertyId,
    propertyName,
}: BusinessInformationOccupantListItem): Occupant => ({
    id: occupantId,
    marketingName: occupantName,
    propertyId,
    propertyName,
    loadStatus: LoadStatus.INITIAL_STATE,
});
